import { useEffect, useRef } from "react";

export const VelocityBlob = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    let vel = 0;
    let lastY = window.scrollY;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    const onScroll = () => {
      const y = window.scrollY;
      vel += y - lastY;
      lastY = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const N = 10;
    const blob = (cx, cy, R, t, stretch, phase, color) => {
      const squash = 1 / Math.sqrt(stretch);
      ctx.beginPath();
      const pts = [];
      for (let i = 0; i < N; i++) {
        const a = (i / N) * Math.PI * 2;
        const wob = 1 + Math.sin(t * 0.0006 + phase + i * 1.7) * 0.12;
        pts.push([cx + Math.cos(a) * R * wob * squash, cy + Math.sin(a) * R * wob * stretch]);
      }
      ctx.moveTo((pts[0][0] + pts[N - 1][0]) / 2, (pts[0][1] + pts[N - 1][1]) / 2);
      for (let i = 0; i < N; i++) {
        const p = pts[i];
        const q = pts[(i + 1) % N];
        ctx.quadraticCurveTo(p[0], p[1], (p[0] + q[0]) / 2, (p[1] + q[1]) / 2);
      }
      ctx.closePath();
      const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, R * 1.5);
      g.addColorStop(0, color);
      g.addColorStop(1, "rgba(212,175,55,0)");
      ctx.fillStyle = g;
      ctx.fill();
    };

    const draw = (t) => {
      vel *= 0.9;
      const stretch = 1 + Math.min(Math.abs(vel) / 250, 0.55);
      ctx.clearRect(0, 0, w, h);
      blob(w * 0.8, h * 0.45, Math.min(w, h) * 0.24, t, stretch, 0, "rgba(212,175,55,0.10)");
      blob(w * 0.12, h * 0.75, Math.min(w, h) * 0.18, t, stretch, 2.4, "rgba(232,213,206,0.35)");
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return <canvas ref={ref} aria-hidden="true" data-testid="velocity-blob" className="pointer-events-none fixed inset-0 z-0" />;
};
